import React from 'react'
import Icon from './Icon'

export default ({ top, bottom, action, icon, contentStatus, text, sign, color }) => {
	let containerClass = ''
	if (top) { containerClass += ' top' }
	if (bottom) { containerClass += ' bottom' }
	return (
		<div>
			<div className={'capps-menu-container' + containerClass} onTouchTap={action}>
				{icon
					? (<div className={icon ? 'capps-menu-icon icon-' + icon : null} />)
					: null
				}
				<div className='capps-text'>{text}</div>
				{ String(action).includes('window.open')
					? <div className='capps-icon'><Icon name='link' size='20' color='dark' /></div>
					: null
				}
				{ contentStatus === 'restricted'
					? <div className='capps-icon'><Icon name='lock-outline' size='20' color='dark' /></div>
					: null
				}
				{ contentStatus === 'trial'
					? <div className='capps-icon'><Icon name='lock-open-outline' size='20' color='dark' /></div>
					: null
				}
				{ contentStatus === 'available'
					? <div className='capps-icon'><Icon name='book-open-page-variant' size='20' color='dark' /></div>
					: null
				}
				<div className='capps-contactinfobox'>
					<div className='capps-contactinfo'>
						<span style={{ marginRight: '8px', marginTop: '5px' }}>{sign.charAt(0).toUpperCase() + sign.slice(1)}</span><span className={'astro ' + sign} style={{ marginTop: '7px' }} />
					</div>
					<div className='capps-contactinfo'>
						<span className={`capps-compatibility ${color}`} style={{ marginRight: '8px', marginTop: '2px' }} />
					</div>
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/Components/Display/Item.js